import styled from 'styled-components'

import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  width: 100%;
`

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const StatisticsGroup = styled(StatisticGroup)`
  width: 100%;
`

export const TopRegionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  font-size: 14px;
`

export const TopProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  font-size: 14px;
  img {
    width: 100px;
    height: 100px;
    aspect-ratio: 1/1;
    object-fit: contain;
  }
`

export const RightStatisticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  width: 100%;
`
